import { Button, Card, Input, Space } from "antd";
import React from "react";

const SubTotal = ({ current }) => {
  const cardTitle = (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        fontSize: "larger",
        fontWeight: "600",
      }}
    >
      <span>Subtotal</span>
      <span>$232.00</span>
    </div>
  );
  return (
    <div>
      <Card title={cardTitle}>
        <span style={{ fontWeight: "500" }}>Enter discount code</span>
        <Space.Compact
          size="large"
          style={{
            width: "100%",
            marginTop: "2px",
          }}
        >
          <Input placeholder="Code..." size="large" />
          <Button type="primary" size="large" style={{ marginTop: "-1px" }}>
            Apply
          </Button>
        </Space.Compact>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontWeight: "600",
            marginTop: "18px",
            padding: "0px 4px",
          }}
        >
          <span>Delivery charges</span>
          <span>$5.00</span>
        </div>
        <hr />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontSize: "larger",
            fontWeight: "600",
          }}
        >
          <span>Grandtotal</span>
          <span>$232.00</span>
        </div>
      </Card>
    </div>
  );
};

export default SubTotal;
